import React, { useState, useEffect } from 'react';
import axios from 'axios';
import CreateSkebbyAlias from './CreateSkebbyAlias';
import CreateGeneralAlias from './CreateGeneralAlias';
import Alert from '../helpers/Alert';
/**
 * creates alias for SMS providers
 * @returns JSX
 */
const CreateAlias = () => {
  const [providerListOptions, setProviderListOptions] = useState([]);
  const [providerTypesOptions, setProviderTypesOptions] = useState([]);
  const [formValues, setFormValues] = useState({});

  useEffect(() => {
    getProviderTypes();
  }, []);

  useEffect(() => {
    if (formValues['provider_type_id']) {
      getProviderList();
    }
    // eslint-disable-next-line
    }, [formValues['provider_type_id']]);
  /**
   * generic function to handle input
   * @param {string} control
   * @param {any} value
   */
  const handleControl = (control, value) => {
    setFormValues({ ...formValues, [control]: value });
  };
  /**
   * gets SMS providers list
   */
  const getProviderList = async () => {
    try {
      const token = localStorage.getItem('token');
      const { data } = await axios.get(`/api/provider/provider-by-type/${formValues['provider_type_id']}`, {
        headers: { authorization: token }
      });
      setProviderListOptions(data);
    } catch (err) {
      const { data } = err.response;
      Alert('error', 'Server Error', data);
    }
  };
  /**
   * gets SMS provider types
   */
  const getProviderTypes = async () => {
    try {
      const token = localStorage.getItem('token');
      const { data } = await axios.get('/api/provider/provider-types', { headers: { authorization: token } });
      setProviderTypesOptions(data);
    } catch (err) {
      const { data } = err.response;
      Alert('error', 'Server Error', data);
    }
  };

  console.log(formValues);

  return (
    <>
      <div className='container-fluid'>
        <div className='row'>
          <div className='card'>
            <div className='card-body'>
              <h4 className='card-title'>Select Provider</h4>
              <div className='form-group'>
                <div className='col-md-9'>
                  <label className='mr-3'>Provider Type</label>
                  <select
                    name='provider_type_id'
                    className='form-control  form-control-lg'
                    onChange={(e) => handleControl('provider_type_id', e.target.value)}
                  >
                    <option value=''>Select Provider</option>
                    {providerTypesOptions.map(({ provider_type_id, provider_name }, idx) => {
                      return (
                        <option key={idx} value={provider_type_id}>
                          {provider_name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className='form-group'>
                <div className='col-md-9'>
                  <label className='mr-3'>Provider Name</label>
                  <select
                    name='provider'
                    className='form-control  form-control-lg'
                    onChange={(e) => handleControl('provider_id', e.target.value)}
                  >
                    <option value=''>Select Provider</option>
                    {providerListOptions.map(({ provider_id, provider_name }, idx) => {
                      return (
                        <option key={idx} value={provider_id}>
                          {provider_name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              {formValues && formValues['provider_id'] && formValues['provider_type_id'] === '1' ? (
                <CreateSkebbyAlias provider_id={formValues['provider_id']} />
              ) : formValues && formValues['provider_id'] && (formValues['provider_type_id'] === '2' || '4') ? (
                <CreateGeneralAlias provider_id={formValues['provider_id']} />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateAlias;
